import React, {FC, memo, useEffect, useState} from 'react';
import {BaseFieldProps, BaseFieldWrapper} from '../baseField';
import {DictionaryItem} from '../../dictionaries/model';
import {getRequestPromise} from '../../httpWrapper/request';
import axios from 'axios';
import {Platform} from 'react-native';
import {DADATA_TOKEN} from 'react-native-dotenv';

const MIN_QUERY_LENGTH = 3;
const SUGGEST_DEBOUNCE_MS = 600;

export interface AddressSelectProps {
  name: string;
  label: string;
  value: string;
  baseFieldProps?: Partial<BaseFieldProps>;
  onChange: React.Dispatch<string>;
  setAddress?: React.Dispatch<React.SetStateAction<string>>;
}

const _AddressSelect: FC<AddressSelectProps> = ({name, label, value, baseFieldProps, onChange, setAddress}) => {
  const [selectOptions, setSelectOptions] = useState<DictionaryItem[]>([]);
  const [areOptionsLoading, setAreOptionsLoading] = useState(false);

  useEffect(() => {
    const query = value?.trim() ?? '';
    if (query.length < MIN_QUERY_LENGTH) {
      setSelectOptions([]);
      setAreOptionsLoading(false);
      return;
    }

    const cancelTokenSource = axios.CancelToken.source();
    const timer = setTimeout(async () => {
      setAreOptionsLoading(true);
      try {
        const apiToken = Platform.OS === 'web' ? process.env.REACT_APP_DADATA_TOKEN : DADATA_TOKEN;

        const result = await getRequestPromise('https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address', {
          method: 'post',
          data: {
            count: 10,
            query,
            locations: [
              {
                region: 'Свердловская',
              },
            ],
          },
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Token ${apiToken}`,
          },
          cancelToken: cancelTokenSource.token,
        });
        setSelectOptions(
          result.data.suggestions.map((item: {value: string}, i: number) => ({id: i, value: item.value})),
        );
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error('Ошибка загрузки адресов', err);
        }
      } finally {
        setAreOptionsLoading(false);
      }
    }, SUGGEST_DEBOUNCE_MS);

    return () => {
      clearTimeout(timer);
      cancelTokenSource.cancel();
    };
  }, [value]);

  return (
    <BaseFieldWrapper
      {...baseFieldProps}
      variant='outlined'
      type='selectDinamic'
      name={name}
      label={label}
      input={{
        value,
        onChange: (val: any) => {
          onChange(Platform.OS === 'web' ? val?.target?.value : val);
        },
      }}
      values={selectOptions}
      iosPlaceholderItem={{id: -1, value: '', label: 'Выберите адрес'}}
      areOptionsLoading={areOptionsLoading}
      isSearchEnabled
      shouldFilterOptions={false}
      autoCapitalize='none'
      onCustomBlur={() => {}}
      setAddress={setAddress}
      containerStyle={Platform.OS === 'web' ? {height: 100} : undefined}
    />
  );
};

export const AddressSelect = memo(_AddressSelect);
